import React from "react";
import { Card, Row, Col, Tag } from "antd";
import { graphql, StaticQuery } from "gatsby";
import Layout from "../../components/TheLayout";

const TeachingCard = ({ data }) => {
  const { title, description, level, link } = data.frontmatter;
  return (
    <Col md={{ span: 12 }}>
      <a href={link}>
        <Card
          hoverable
          bordered={false}
          style={{ minHeight: "250px", marginBottom: "16px" }}
        >
          <h2>{title}</h2>
          <p>{description}</p>
          <div>
            {level.map(l =>
              l === "basic academic studies" ? (
                <Tag key={l} color="#3bb811" style={{ marginBottom: "8px" }}>
                  {l}
                </Tag>
              ) : l === "graduate academic studies" ? (
                <Tag key={l} color="#474487" style={{ marginBottom: "8px" }}>
                  {l}
                </Tag>
              ) : (
                <Tag key={l} color="#f57a00" style={{ marginBottom: "8px" }}>
                  {l}
                </Tag>
              )
            )}
          </div>
        </Card>
      </a>
    </Col>
  );
};

const TeachingPage = () => {
  return (
    <Layout>
      <div
        style={{
          maxWidth: "80%",
          margin: "20px auto",
          textAlign: "center"
        }}
      >
        <h1 style={{ color: "#474487" }}>Teaching</h1>
      </div>
      <StaticQuery
        query={graphql`
          query {
            allMarkdownRemark(
              filter: {
                frontmatter: { templateKey: { eq: "teaching-subject" } }
              }
              sort: { order: ASC, fields: [frontmatter___date] }
            ) {
              edges {
                node {
                  id
                  frontmatter {
                    title
                    description
                    level
                    link
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { edges: subjects } = data.allMarkdownRemark;
          return (
            <div style={{ maxWidth: "1140px", margin: "16px auto" }}>
              <Row
                gutter={16}
                style={{ marginLeft: "unset", marginRight: "unset" }}
              >
                {subjects.map(subject => (
                  <TeachingCard key={subject.node.id} data={subject.node} />
                ))}
              </Row>
            </div>
          );
        }}
      />
    </Layout>
  );
};

export default TeachingPage;
